export default {
	policyInfoHeader: 'Informace o PS',
	PSNumber: 'Číslo PS',
	proposalNumber: 'Číslo návrhu GP',
	insurance: 'Pojištění',
	PSStatus: 'Stav PS',
	dateNegotiation: 'Datum sjednání PS',
	dateBegining: 'Datum počátku PS',
	dateEnd: 'Datum ukončení PS',

	clientInfoHeader: 'Informace o klientovi',
	businessIn: 'IČO',
	fullName: 'Příjmení a jméno',
	street: 'Ulice',
	city: 'Obec',
	PSC: 'PSČ',
	mobile: 'Mobil',
	phone: 'Telefon',
	email: 'E-mail',
	emailKC: 'E-mail z KC',
	phoneKC: 'Telefon z KC',
	phoneMaintenance: 'Telefon od správy',
	claimNo: 'Číslo PU',
};
